import {Injectable} from "@angular/core";
import {GruppeId, MedlemId, MøteId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {firstValueFrom} from "rxjs";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {MøteOpprettDialogKomponent} from "../modale/møte-opprett-dialog/møte-opprett-dialog";
import {MatDialog} from "@angular/material/dialog";
import {Temporal} from "temporal-polyfill";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {SendMøteinnkallingDialogKomponent} from "../modale/send-møteinnkalling-dialog/send-møteinnkalling-dialog";
import {erIkkeTomListe} from "felles-ng2/støttefunksjoner/lister";
import {MøteRedigerDialogKomponent, Steg} from "web-ng2/moduler/møte/modale/møte-rediger-dialog/møte-rediger-dialog";
import {NavigasjonDeaktivering} from "web-ng2/tjenester/NavigasjonDeaktivering";
import {MøteDatatjeneste} from "felles-ng2/tjenester/datalager/MøteDatatjeneste";
import {førsteVerdiLevertFraServer} from "felles-ng2/tjenester/datalager/DataOgMeta";
import {MøtePubliserDialogKomponent} from "web-ng2/moduler/møte/modale/møte-publiser-dialog/møte-publiser-dialog";
import {MøteprotokollSendTilSigneringDialogKomponent} from "web-ng2/moduler/møteprotokoll/modale/møteprotokoll-send-til-signering-dialog/møteprotokoll-send-til-signering-dialog";
import {StartMøteTranskripsjonDialogKomponent} from "../modale/start-møte-transkripsjon-dialog/start-møte-transkripsjon-dialog";
import PlainDate = Temporal.PlainDate;
import {MøtedeltakereDatatjeneste} from "felles-ng2/tjenester/datalager/MøtedeltakereDatatjeneste";

@Injectable()
export class Møtedialoger {

    constructor(private matDialog: MatDialog,
                private navigasjon: Navigasjon,
                private navigasjonDeaktivering: NavigasjonDeaktivering,
                private møteDatatjeneste: MøteDatatjeneste,
                private møtedeltakereDatatjeneste: MøtedeltakereDatatjeneste) {
    }

    async visOpprett(valgtGruppeId: GruppeId | null = null, valgtStartdato: PlainDate | null = null) {
        const resultat = await firstValueFrom(MøteOpprettDialogKomponent.vis(this.matDialog, valgtGruppeId, valgtStartdato).beforeClosed());

        if (erNil(resultat)) return; //bruker avbrøt

        this.navigasjon.gåTilMøte(resultat.opprettetMøte.id);
        if (resultat.sendInnkalling && erIkkeTomListe(resultat.opprettetMøte.deltakere))
            SendMøteinnkallingDialogKomponent.vis(this.matDialog, Promise.resolve(resultat.opprettetMøte), Promise.resolve(resultat.opprettetMøte.deltakere));
    }

    async visRediger(møteId: MøteId, initieltSteg = Steg.detaljer) {
        const resultat = await this.navigasjonDeaktivering.medDeaktivertNavigasjon(() =>
          firstValueFrom(MøteRedigerDialogKomponent.vis(this.matDialog, møteId, initieltSteg).beforeClosed()));

        if (erNil(resultat)) return; //bruker avbrøt

        if (resultat.sendInnkalling && erIkkeTomListe(resultat.nyeDeltakere))
            SendMøteinnkallingDialogKomponent.vis(this.matDialog, Promise.resolve(resultat.oppdatertMøte),Promise.resolve(resultat.oppdatertMøte.deltakere),  resultat.nyeDeltakere);
    }

    async visSendInnkalling(møteId: MøteId, forhåndsvalgteMottakere: MedlemId[] | null = null): Promise<void> {
        const møte = førsteVerdiLevertFraServer(this.møteDatatjeneste.hentMedMeta(møteId));
        //når møte-promiset har resolvet vet vi at data er oppdatert i møtedeltakereDatatjeneste
        const deltakerer = møte.then(møte => firstValueFrom(this.møtedeltakereDatatjeneste.finnTilknyttetMøteFraLokallager(møte.id)));
        await firstValueFrom(SendMøteinnkallingDialogKomponent.vis(this.matDialog, møte, deltakerer, forhåndsvalgteMottakere).beforeClosed());
    }

    async visPubliserMøte(møteId: MøteId): Promise<void> {
        const møte = førsteVerdiLevertFraServer(this.møteDatatjeneste.hentMedMeta(møteId));
        await firstValueFrom(MøtePubliserDialogKomponent.visPubliserMøte(this.matDialog, møte).beforeClosed());
    }

    async visPubliserProtokoll(møteId: MøteId): Promise<void> {
        const møte = førsteVerdiLevertFraServer(this.møteDatatjeneste.hentMedMeta(møteId));
        await firstValueFrom(MøtePubliserDialogKomponent.visPubliserProtokoll(this.matDialog, møte).beforeClosed());
    }

    async visSendSignerProtokollInvitasjon(møteId: MøteId): Promise<void> {
        const møte = førsteVerdiLevertFraServer(this.møteDatatjeneste.hentMedMeta(møteId));
        await firstValueFrom(MøteprotokollSendTilSigneringDialogKomponent.vis(this.matDialog, møte).beforeClosed());
    }

    /**
     * Lar bruker velge mikrofon og starter transkripsjonen av møtet.
     *
     * Opptaket eies av MøteTranskripsjon og lever videre etter at dialogen er lukket, så her er det
     * ingenting å følge opp i etterkant.
     */
    async visStartTranskripsjon(møteId: MøteId): Promise<void> {
        const møte = await førsteVerdiLevertFraServer(this.møteDatatjeneste.hentMedMeta(møteId));
        await StartMøteTranskripsjonDialogKomponent.vis(this.matDialog, møte);
    }

}
